var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"spinner"},[_c('img',{attrs:{"src":require(`images/png/spinner-50.png`),"alt":""}}),_c('span',{staticClass:"spinner__label",style:([this.color ? {'color' : `#${this.color}`} : null])},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }